import styled, {css} from 'styled-components';

export const Cell = styled.div`
    @media only screen and (min-width: 901px) {
        &:not(.mobileVersion) {
            height: ${props => props.height ? props.height : '100%'};
            top: 17.5%;
        }
    }
    @media only screen and (max-width: 900px) {
        height: auto;
        top: 0;
        padding: 2.2vw;
        box-sizing: border-box;
    }
    &.mobileVersion {
        height: auto;
        top: 0;
        padding: 2.2vw;
        box-sizing: border-box;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    ${props => {
        switch(props.animType) {
            case 'fade-in':
                return css`
                    opacity: 0;
                    left: 0;
                `;
            case 'scroll-from-right':
                return css`
                    position: fixed;
                    transform: translate(2000px, 0);
                    left: ${props => props.left};
                `;
            case 'scroll-from-left':
                return css`
                    position: fixed;
                    transform: translate(-2000px, 0);
                    left: ${props => props.left};
                `;
            case 'scroll-from-top':
                return css`
                    opacity: 0;
                    transform: translate(0, -2000px);
                    left: ${props => props.left};
                `;
            case 'scroll-from-bottom':
                return css`
                    opacity: 0;
                    transform: translate(0, 2000px);
                    left: ${props => props.left};
                `;
        }
    }}
`;

export const ImgContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s;
    background-color: transparent;
    @media only screen and (max-width: 900px) {
        max-height: 100%;
    }
    &.mobileVersion {
        max-height: 100%;
    }
    @media only screen and (min-width: 901px) {
        &:not(.mobileVersion) {
            height: 100%;
        }
    }
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ CSS styles go here */
        background-color: transparent;
    }
    cursor: pointer;
    pointer-events: all;
    text-align: center;
`;

export const Img = styled.img`
    max-width: 100%;
    max-height: 100%;
    transition: opacity 0.5s;
    opacity: 1;
`;

export const Magnify = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 10000;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 50%;
    width: 4vw;
    height: 4vw;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.5s;
    pointer-events: none;
    > img {
        width: 2.3vw;
    }
    @media only screen and (max-width: 900px) {
        display: none;
    }
    &.mobileVersion{
        display: none;
    }
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ CSS styles go here */
        left: 50%;
    }
`;